import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ice-machines',
  templateUrl: './ice-machines.component.html',
  styleUrls: ['./ice-machines.component.scss']
})
export class IceMachinesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/ice-machines/ice-machines.component.ts